import { useCallback, useEffect, useRef, useState } from "react"
import {
  aIsCaptionsOpen,
  aIsPlaying,
  aIsQualityOpen,
  aIsSpeedOpen,
  useAtom,
  useAtomValue,
} from "~/atoms"
import { debounceFunc } from "~/utils/misc"

export default function useIsControlBarVisible() {
  const [isControlBarVisible, setIsControlBarVisible] = useState(true)
  const isPlaying = useAtomValue(aIsPlaying)
  const [isCaptionsOpen, setIsCaptionsOpen] = useAtom(aIsCaptionsOpen)
  const [isQualityOpen, setIsQualityOpen] = useAtom(aIsQualityOpen)
  const [isSpeedOpen, setIsSpeedOpen] = useAtom(aIsSpeedOpen)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const shouldHide = useRef(false)

  useEffect(() => {
    shouldHide.current =
      !isCaptionsOpen && !isQualityOpen && !isSpeedOpen && isPlaying
  }, [isCaptionsOpen, isQualityOpen, isSpeedOpen, isPlaying])

  const handleInteraction = useCallback((e: Event | null) => {
    if ((e?.target as HTMLElement)?.getAttribute("data-disable-control")) {
      return
    }
    document.getElementById("player")!.style.cursor = "default"
    setIsControlBarVisible(true)
    clearTimeout(timeoutRef.current || undefined)
    timeoutRef.current = setTimeout(() => {
      if (shouldHide.current) {
        setIsControlBarVisible(false)
        document.getElementById("player")!.style.cursor = "none"
      }
    }, 2000)
  }, [])

  useEffect(() => {
    const debouncedOnMouseMove = debounceFunc(handleInteraction, 5)
    document.documentElement.addEventListener("mousemove", debouncedOnMouseMove)
    document.documentElement.addEventListener("click", handleInteraction)
    document.documentElement.addEventListener("touchstart", handleInteraction)
    document.documentElement.addEventListener("focusin", handleInteraction)
    return () => {
      clearTimeout(timeoutRef.current || undefined)
      document.documentElement.removeEventListener(
        "mousemove",
        debouncedOnMouseMove
      )
      document.documentElement.removeEventListener("click", handleInteraction)
      document.documentElement.removeEventListener(
        "touchstart",
        handleInteraction
      )
      document.documentElement.removeEventListener("focusin", handleInteraction)
    }
  }, [handleInteraction])

  useEffect(() => {
    if (!isCaptionsOpen && !isQualityOpen && !isSpeedOpen) {
      handleInteraction(null)
    }
  }, [handleInteraction, isCaptionsOpen, isQualityOpen, isSpeedOpen, isPlaying])

  useEffect(() => {
    const onWindowBlur = () => {
      setIsCaptionsOpen(false)
      setIsQualityOpen(false)
      setIsSpeedOpen(false)
      // setIsControlBarVisible(false)
    }
    window.addEventListener("blur", onWindowBlur)
    return () => window.removeEventListener("blur", onWindowBlur)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { isControlBarVisible, handleInteraction }
}
